import React from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { getDebugLogger } from '../../utils/logger'

const STALE_TIME = 5 * 60 * 1000 // 5 minutes

const debug = getDebugLogger('ReactQueryProviderWrapper')

export function ReactQueryProviderWrapper({ children }) {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: STALE_TIME
      }
    }
  })

  return (
    <QueryClientProvider client={queryClient}>
      {children}
    </QueryClientProvider>
  )
}
